// frontend/src/services/api/auth.js

import axios from "axios";
import { BASE_URL } from "../common";
import {
  fetchCurrentUser,
  getSessionToken,
  loginWithPin,
  logoutSession,
  sanitizeToken,
  clearSessionToken,
} from "./postgrest";

const CHECK_AUTHENTICATE_MISSING_TOKEN_ERROR =
  "Token ausente para validação de sessão";

export const gateway = axios.create({
  baseURL: `${BASE_URL}/api`,
  timeout: 60000,
  headers: {
    "content-type": "application/json",
  },
});

export const logar = (body) => {
  return loginWithPin(body);
};

export const checkAuthenticate = (token) => {
  const sanitizedToken = sanitizeToken(token);

  if (!sanitizedToken) {
    return Promise.reject(new Error(CHECK_AUTHENTICATE_MISSING_TOKEN_ERROR));
  }

  return fetchCurrentUser(sanitizedToken);
};

export const account = (token) => checkAuthenticate(token);

export const finalizarSessao = async (token) => {
  const sanitizedToken = sanitizeToken(token ?? getSessionToken());

  if (!sanitizedToken) {
    clearSessionToken();
    return { data: null };
  }

  try {
    return await logoutSession(sanitizedToken);
  } finally {
    clearSessionToken();
  }
};

export const createUser = async (body) => {
  return gateway.post("/register", body);
};
